// @ts-strict-ignore
/* eslint-disable camelcase */
import React from 'react'
import { assetsPublicPath } from 'server/helpers/env'

interface SelectProps {
  name: string
  placeholder?: string
  value: string
  options: Array<object>
  onChange?: Function
  onBlur?: Function
  buttonActions?: Record<string, string | number>
  styles?: object
  brand?: 'money' | 'uswitch' | 'confused'
  hasError?: boolean
  ref?: React.Ref<HTMLSelectElement> | undefined
}

const Select: React.FC<SelectProps> = React.forwardRef(
  ({ name, value, options, onChange, buttonActions, styles = {}, brand = 'money' }, ref) => (
    <select
      className='Select'
      id={name}
      name={name}
      onChange={onChange}
      value={value}
      style={{
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'calc(100% - 10px) 50%',
        backgroundImage: `url(${assetsPublicPath}/icons/${brand}/chevron-down.svg?v=13#chevron-down)`,
        ...styles,
      }}
      {...buttonActions}
      ref={ref}
    >
      {options.map((ele: any, index: number) => {
        return (
          <option key={index} value={ele.value}>
            {ele.text}
          </option>
        )
      })}
    </select>
  ),
)

export default Select
